import React from 'react';

const TimerContext = React.createContext(null);

export default TimerContext
